import { createTheme as e } from "@mui/material";
const o = e({
  breakpoints: {
    values: {
      mobile: 0,
      tablet: 768,
      desktop: 1070,
      mediumDesktop: 1280,
      largeDesktop: 1440,
      xLargeDesktop: 1560
    }
  }
});
export {
  o as t
};
//# sourceMappingURL=breakpoints-DvaoDEis.mjs.map
